import React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import Card from '@material-ui/core/Card';

class ViewAll extends React.Component {

  render() {
    return (
        <div class="mobileview">
            <Grid style={{marginLeft: '3%'}}>
              {
                this.props.viewallArray.map((c) => {
                  let type2 = c.name+' - '+this.props.type2;
                    return (
                        <Grid.Column mobile={16} tablet={16} computer={5}>
                            <Card  id="flex-group-item" onClick={ () => { this.props.changeState(c.id, c.name, this.props.type1, type2) }}>
                                <center style={{margin: '5px'}}>
                                  <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/"+this.props.imageLink+"/"+c.id+".jpg"} style={{width: '200px', height: '200px', borderRadius: '5px'}} />
                                  <b>
                                  {c.name}<br/>
                                  {'('+c.tamil_name+')'}
                                  </b>
                                </center>
                            </Card>
                        </Grid.Column>
                    )
                })
              }
            </Grid>
        </div>
    );
  }
}

export default ViewAll;
